module.exports = __webpack_public_path__ + "static/media/text-width.52bf2b20.svg";